export default __webpack_public_path__ + "media/images/logo-bermuda-0615d1592e36ab23a548e6a5e51f5349.svg";